// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/straight-and-level.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/straight-and-level/straight-and-level.js';

mount([g0]);
